// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__g7TIy","active":"Menu_active__EZmst","removeDelay":"Menu_removeDelay__xooe1","menu":"Menu_menu__u0Ej+","list":"Menu_list__TCUFF","layer":"Menu_layer__lxGXA"};